module.exports = __webpack_public_path__ + "img/250460827_2025_4-4.f0ef4328.png";